var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 39 27",
    fill: "currentColor",
    stroke: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0133 8.08939H3.48976C2.12039 8.08939 1 6.9621 1 5.58431V3.50509C1 2.12729 2.12039 1 3.48976 1H16.0133C17.3826 1 18.503 2.12729 18.503 3.50509V5.58431C18.503 6.9621 17.4075 8.08939 16.0133 8.08939ZM3.48976 2.00203C2.66814 2.00203 1.9959 2.67841 1.9959 3.50509V5.58431C1.9959 6.41098 2.66814 7.08736 3.48976 7.08736H16.0133C16.8349 7.08736 17.5071 6.41098 17.5071 5.58431V3.50509C17.5071 2.67841 16.8349 2.00203 16.0133 2.00203H3.48976Z",
    fill: "inherit",
    stroke: "inherit",
    strokeWidth: 0.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8895 17.0315H23.4905C22.1211 17.0315 21.0007 15.9042 21.0007 14.5264V12.4472C21.0007 11.0694 22.1211 9.94214 23.4905 9.94214H35.8895C37.2589 9.94214 38.3793 11.0694 38.3793 12.4472V14.5264C38.3793 15.9042 37.2589 17.0315 35.8895 17.0315ZM23.4905 10.9442C22.6689 10.9442 21.9966 11.6205 21.9966 12.4472V14.5264C21.9966 15.3531 22.6689 16.0295 23.4905 16.0295H35.8895C36.7111 16.0295 37.3834 15.3531 37.3834 14.5264V12.4472C37.3834 11.6205 36.7111 10.9442 35.8895 10.9442H23.4905Z",
    fill: "inherit",
    stroke: "inherit",
    strokeWidth: 0.6
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8888 25.9999H3.48976C2.12039 25.9999 1 24.8726 1 23.4948V21.4156C1 20.0378 2.12039 18.9105 3.48976 18.9105H15.8888C17.2581 18.9105 18.3785 20.0378 18.3785 21.4156V23.4948C18.3785 24.8726 17.2581 25.9999 15.8888 25.9999ZM3.48976 19.9126C2.66814 19.9126 1.9959 20.5889 1.9959 21.4156V23.4948C1.9959 24.3215 2.66814 24.9979 3.48976 24.9979H15.8888C16.7104 24.9979 17.3826 24.3215 17.3826 23.4948V21.4156C17.3826 20.5889 16.7104 19.9126 15.8888 19.9126H3.48976Z",
    fill: "inherit",
    stroke: "inherit",
    strokeWidth: 0.6
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4631 10.945C28.1893 10.945 27.9652 10.7196 27.9652 10.444V5.48393C27.9652 5.23342 27.766 5.05807 27.5419 5.05807H17.7122C17.4383 5.05807 17.6674 4.609 17.6674 4.33344C17.6674 4.05788 17.3934 4.05603 17.6673 4.05603H27.517C28.3137 4.05603 28.9362 4.70735 28.9362 5.48393V10.4691C28.9611 10.7196 28.737 10.945 28.4631 10.945Z",
    fill: "inherit",
    stroke: "inherit",
    strokeWidth: 0.6
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5043 22.9432H18.1554C17.8815 22.9432 17.6575 22.7178 17.6575 22.4422C17.6575 22.1666 17.8815 21.9412 18.1554 21.9412H24.5043C24.7533 21.9412 24.9276 21.7408 24.9276 21.5153V16.5302C24.9276 16.2546 25.1517 16.0292 25.4255 16.0292C25.6994 16.0292 25.9235 16.2546 25.9235 16.5302V21.5153C25.9484 22.2919 25.301 22.9432 24.5043 22.9432Z",
    fill: "inherit",
    stroke: "inherit",
    strokeWidth: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlow);
export default __webpack_public_path__ + "static/media/flow.f8d709f0.svg";
export { ForwardRef as ReactComponent };